import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.607 17.225a7.488 7.488 0 0 0-5.982-2.975 7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0a8.966 8.966 0 0 1-5.981 2.275 8.966 8.966 0 0 1-5.982-2.275m8.982-8.975a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }